import React from "react";
import aboutcontent from "../../images/about/about-content.svg";

const AboutContent = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between align-items-center">
          <div className="col-lg-6">
            <div className="px-4">
              <img src={aboutcontent} alt="About" />
            </div>
          </div>
          <div className="col-lg-6 d-lg-flex flex-lg-column gap-3">
            <h2 className="heading_text text-dark text-start mb-0">About Us</h2>
            {/* <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK is a revolutionary rewards and loyalty platform based
              in the United Kingdom. Our mission is to help businesses grow
              through smart, innovative advertising, while giving customers real customer benefits, growing rewards through participation every time they shop.
            </p> */}
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK is a UK-based advertising and customer loyalty platform.
            </p>
            {/* <p className="info_description opacity-50 text-dark mb-0">
              We’ve created a unique non-investment digital reward system where
              customers earn free TopCoin UK with every purchase from
              participating shops, restaurants, and companies. These TopCoin go
              into their personal Customer Wallets and unlock cash rewards funded by participating businesses, unlock promotional cash rewards provided by TopCoin UK
              through a structured, transparent system. The more you participate, the more rewards you may unlock.
            </p> */}
            <p className="info_description opacity-50 text-dark mb-0">
              Our purpose is to help businesses promote their products and services through structured promotional rewards, while giving customers added value when they shop with participating retailers.
            </p>
            {/* <p className="info_description opacity-50 text-dark mb-0">
              Unlike traditional points or loyalty schemes, TopCoin UK 
              do not expire and can be used within the TopCoin UK rewards system.
              Every customer and business is connected to a secure,
              blockchain-based network where rewards and wallets grow together.
            </p> */}
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK operates a non-investment loyalty programme where customers receive free TopCoin when making purchases from participating shops, 
              restaurants, and businesses. TopCoin is recorded in personal customer wallets and may contribute toward unlocking promotional reward benefits funded by participating businesses, 
              in accordance with programme rules.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin is a promotional loyalty credit. It is not money, 
              not a cryptocurrency, not an investment, and does not provide ownership, 
              profit rights, or financial returns. Rewards are promotional in nature and are subject to programme conditions.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              Unlike traditional loyalty points that may expire, 
              TopCoin remains recorded within the TopCoin UK system and 
              may be used within the platform in line with published terms and conditions.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK does not provide financial services, 
              investment products, payment services, 
              or regulated financial instruments.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;
